export default class Assets {
   static getAssets = () => window.templateDirectoryUri + 'assets/'
   static getGutenberg = () => window.templateDirectoryUri + 'src/gutenberg/'

   static getImage = imageName => Assets.getAssets() + 'img/' + imageName
   static getImageGutenberg = imageName => Assets.getGutenberg() + imageName
}